import { BoardStates } from './BoardState'
import { BoardAction, BoardActions } from './BoardStateAction'

import type { BoardState } from './BoardState.types'

type Reducer = (action: BoardAction, state: BoardState) => BoardState

const reducePreDeal = (action: BoardAction, state: BoardState) => {
  if (BoardActions.isDealCards(action)) {
    return BoardStates.Deal
  }
  if (BoardActions.isEvalShowdown(action)) {
    return BoardStates.Showdown
  }
  return state
}

const reduceDeal = (action: BoardAction, state: BoardState) => {
  if (BoardActions.isDealFlop(action)) {
    return BoardStates.Flop
  }
  if (BoardActions.isEvalShowdown(action)) {
    return BoardStates.Showdown
  }
  return state
}

const reduceFlop = (action: BoardAction, state: BoardState) => {
  if (BoardActions.isDealTurn(action)) {
    return BoardStates.Turn
  }
  if (BoardActions.isEvalShowdown(action)) {
    return BoardStates.Showdown
  }
  return state
}

const reduceTurn = (action: BoardAction, state: BoardState) => {
  if (BoardActions.isDealRiver(action)) {
    return BoardStates.River
  }
  if (BoardActions.isEvalShowdown(action)) {
    return BoardStates.Showdown
  }
  return state
}

const reduceRiver = (action: BoardAction, state: BoardState) => {
  if (BoardActions.isEvalShowdown(action)) {
    return BoardStates.Showdown
  }
  return state
}

const reduceShowdown = (action: BoardAction, state: BoardState) => {
  if (BoardActions.isResetBoard(action)) {
    return BoardStates.PreDeal
  }
  return state
}

export const BoardReducer: Reducer = (action, state) => {
  if (BoardStates.isPreDeal(state)) {
    return reducePreDeal(action, state)
  }
  if (BoardStates.isDeal(state)) {
    return reduceDeal(action, state)
  }
  if (BoardStates.isFlop(state)) {
    return reduceFlop(action, state)
  }
  if (BoardStates.isTurn(state)) {
    return reduceTurn(action, state)
  }
  if (BoardStates.isRiver(state)) {
    return reduceRiver(action, state)
  }
  if (BoardStates.isShowdown(state)) {
    return reduceShowdown(action, state)
  }

  return state
}
